import { useEffect, useState } from "react";
import "./App.css";
import Home from "./pages/Home";
import { Routes, Route } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { contractAbi, contractAddress } from "./contract";
import Web3 from "web3";
import { Web } from "@mui/icons-material";

function App() {
  const context = useWeb3React();
  const { account, activate, deactivate, error, library } = context;
  const [balance, setBalance] = useState(0);
  const [buyers, setBuyers] = useState(0);

  // const CONNECTABLE_CHAINID = 3;


  const setContractsAndBlockchainData = async () => {
    try {

      if (window.ethereum) {
        // console.log('eth');
        window.web3 = new Web3(window.ethereum);
        window.web3.eth.handleRevert = true;
      } else if (window.web3) {
        // console.log('web3');
        window.web3 = new Web3(window.web3.currentProvider);
        window.web3.eth.handleRevert = true
      } else {
        return;
      }

      const _contract = new window.web3.eth.Contract(contractAbi, contractAddress);
      const jackpotBalance = await _contract.methods.jackpotValue().call();
      // console.log("JACKPOT BALANCE", jackpotBalance);
      setBalance(Web3.utils.fromWei(jackpotBalance, "ether"));

      const _buyers = await _contract.methods.buyerCounter().call();
      // console.log("Buyer Counter", _buyers);
      setBuyers(_buyers);
    } catch (error) {
      // console.log("CONTRACT ERROR", error);
    }
  };
  useEffect(() => {
    setContractsAndBlockchainData();
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Home balance={balance} buyers={buyers} />
          }
        />
      </Routes>
    </>
  );
}

export default App;
